<app-header (newItemEvent)="itemMenu($event)"></app-header>

<!-- <button type="button" class="btn ml-1 round w-100 bg-primary" style="color: white; font-weight: bold;" rippleEffect
    (click)="scrollSection()">Buscar</button> -->


<ng-container *ngIf="listSlider && listSlider.length>0">
    <swiper class="swiper-fade-effect swiper-container swiper-navigation" [config]="swiperFadeEffect">
        
        <div class="row" *ngFor="let sli of listSlider">
            <div class="col-12 vert-center-container">
                <a *ngIf="sli.url != null" href="{{sli.url}}" target="_blank">
                    <img class="img-responsive imgBack" [src]="url+sli.image" alt="">
                </a>
                <img *ngIf="sli.url == null" class="img-responsive imgBack" [src]="url+sli.image" alt="">

                <!-- <div class="vert-center-text">
                </div> -->
                <!-- <div class="bg-transparent d-flex justify-content-center imgArrow">
                    <img src="assets/images/ArrowDown.png" class="img-fluid" style="cursor: pointer;"
                        (click)="itemMenu(1)">
                </div> -->
            </div>
        </div>
    </swiper>
</ng-container>

<div class="row mt-5" *ngIf="domainPage == 'ampisanluis.com'">
    <div class="col-md-12 text-center">
        <a href="http://foro.ampisanluis.com" class="btn btn-primary">Foro Ampi San Luis</a>
    </div>
</div>


<div class="d-flex justify-content-center">
    <div class="mt-5 widthDynamic">

        <h1 class="text-center titlesSize">PROPIEDADES</h1>
        <app-properties id="propertiesSection"></app-properties>
        <br>
        <br>
        <app-grupo-socios id="partnersSection"></app-grupo-socios>
        <!-- <app-mesa-directiva id="mesaDirectivaSection"></app-mesa-directiva> -->
        <br>
        <br>
        
        <app-us id="usSection"></app-us>
        <br>
        <br>
        <app-grupo-beneficios id="benefitsSection"></app-grupo-beneficios>¡
        <br>
        <br>
        <app-events id="eventsSection"></app-events>
    </div>
</div>

<div style="position: fixed; bottom: 20px; right: 20px; z-index: 1000;">
    <button type="button" class="btn btn-icon rounded-circle colorWhatsApp" (click)="sendWhatsapp()"
        style="font-size: 25px; background-color: #25D366; color: white;">
        <i class="fa fa-whatsapp" aria-hidden="true"></i>
    </button>
</div>



<app-footer></app-footer>